export const TRANSLATIONS_EN_PT = {
	Footer_RobertBoschGmbh2021_AllRightsReserved: "Robert Bosch S.A., all rights reserved",
	ContactUs_Mobile_PT: "+351 21 850 00 93",
	ContactUs_Address_PT: "Robert Bosch Portugal S.A.,Av. Infante D. Henrique Lt 2E e 3E,1800-220 Lisboa,Portugal"
};